import { FormattedMessage } from 'react-intl';

import UserGroupIcon from '@/assets/icons/user-group.svg';
import { Skeleton } from '@/components/ui/skeleton';
import { Typography } from '@/components/ui/typography';

interface AudienceDetailsProps {
  audienceSize: number;
  matchScore: number;
  proximity?: number | null;
  isFetching: boolean;
}

export function AudienceDetails({
  audienceSize,
  matchScore,
  proximity,
  isFetching,
}: AudienceDetailsProps) {
  return (
    <div className="flex flex-col gap-2">
      <Typography variant="caption">
        <FormattedMessage
          defaultMessage="Audience details"
          description="Audience details caption"
        />
      </Typography>

      {/* Audience size */}
      <div className="flex items-center justify-between gap-4">
        <Typography variant="subtitle2">
          <FormattedMessage
            defaultMessage="Audience size"
            description="Title for audience name"
          />
        </Typography>
        {isFetching ? (
          <Skeleton className="h-4 w-10" />
        ) : (
          <div className="flex items-center gap-1">
            <img src={UserGroupIcon} alt="User group" className="h-4 w-4" />
            <Typography variant="small1">{audienceSize}</Typography>
          </div>
        )}
      </div>

      {/* Match score */}
      <div className="flex items-center justify-between gap-4">
        <Typography variant="subtitle2">
          <FormattedMessage
            defaultMessage="Match score"
            description="Title for match score"
          />
        </Typography>
        {isFetching ? (
          <Skeleton className="h-4 w-10" />
        ) : (
          <Typography variant="small1">
            {matchScore ? `${matchScore}%` : '-'}
          </Typography>
        )}
      </div>

      {/* Proximity */}
      <div className="flex items-center justify-between gap-4">
        <Typography variant="subtitle2">
          <FormattedMessage
            defaultMessage="Proximity"
            description="Title for proximity"
          />
        </Typography>
        {isFetching ? (
          <Skeleton className="h-4 w-10" />
        ) : (
          <Typography variant="small1">
            {proximity ? (
              <FormattedMessage
                defaultMessage="{proximity} miles"
                description="Proximity miles"
                values={{
                  proximity,
                }}
              />
            ) : (
              '-'
            )}
          </Typography>
        )}
      </div>
    </div>
  );
}
